import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  InputGroup,
  Row,
  Spinner,
} from "react-bootstrap";
// import GoogleLogin from "react-google-login";
import FacebookLogin from "react-facebook-login";
import {
  SIGN_IN_WITH_FACEBOOK,
  // SIGN_IN_WITH_GOOGLE,
  SIGN_IN_WITH_APPLE,
} from "../../assets/images";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { emailRegex, mobileRegex, SignupErrorModal } from "./helpers";
import {
  AppDispatch,
  UserModal,
  getCountriesAction,
  manualSignupAction,
  CountryModal,
  FranchiseModal,
  manualSigninAction,
  RoleSignIn,
  postOauthAction,
  updateGoogleFacebookUserAction,
  UsetInfoUpdateModal,
  setLoaderStateAction,
  appleSignupAction,
} from "../../redux";
// import { SkipButton } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelopeOpenText,
  faEye,
  faEyeSlash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { SET_IS_LOGGED_IN, SET_USER } from "../../redux/types";
import AppleSignin from "react-apple-signin-auth";
import RenderInBrowser from "react-render-in-browser";
import PhoneInput from "react-phone-number-input";

// const clientId =
//   "413867310132-s4e9depk2l56gg6fshlul96nvcqr27da.apps.googleusercontent.com";
interface SignupComponentProps {
  onSuccess: (data: any) => void;
  noSkip?: boolean;
  toggleMode?: (data: boolean) => void;
  hideModal?: () => void;
}

const SignupComponent = (props: SignupComponentProps) => {
  const dispatch = useDispatch<AppDispatch>();
  // const navigate = useNavigate();
  const { countries, franchiseList } = useSelector((state: any) => state.auth);
  const {
    selectedCountry,
    selectedFranchise,
  }: { selectedCountry: CountryModal; selectedFranchise: FranchiseModal } =
    useSelector((state: any) => state.user);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [selectedCountryLocal, setSelectedCountryLocal] = useState<number>(-1);
  const [selectedFranchiseLocal, setSelectedFranchiseLocal] = useState<
    number | undefined
  >(-1);
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
  const [isSignUpLoading, setIsSignUpLoading] = useState<boolean>(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState<boolean>(false);
  const [localUser, setLocalUser] = useState<any>({});
  const [isVerificationModalOpen, setIsVerificationModalOpen] =
    useState<boolean>(false);
  const [isSelectLocationModalOpen, setIsSelectLocationModalOpen] =
    useState<boolean>(false);
  const [errors, setErrors] = useState<SignupErrorModal>({
    firstNameError: "",
    lastNameError: "",
    emailError: "",
    phoneError: "",
    passwordError: "",
    confirmPasswordError: "",
    countryError: "",
    franchiseError: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [localFranchiseList, setLocalFranchiseList] = useState<
    Array<FranchiseModal>
  >([]);
  useEffect(() => {
    dispatch(getCountriesAction());
  }, [dispatch]);

  useEffect(() => {
    if (countries?.length > 0 && franchiseList?.length > 0) {
      setLocalFranchiseList(
        franchiseList?.filter(
          (x: FranchiseModal) => x.country_id === selectedCountryLocal
        )
      );
    }
  }, [countries, franchiseList, selectedCountry, selectedCountryLocal]);

  useEffect(() => {
    if (selectedCountry?.id) {
      setSelectedCountryLocal(selectedCountry?.id);
    } else {
      setSelectedCountryLocal(-1);
    }
    if (selectedFranchise?.id) {
      setSelectedFranchiseLocal(selectedFranchise?.id);
    } else {
      setSelectedFranchiseLocal(-1);
    }
  }, [selectedCountry, selectedFranchise]);

  const validate = () => {
    let hasError = false;
    let _errors: SignupErrorModal = {
      firstNameError: "",
      lastNameError: "",
      emailError: "",
      phoneError: "",
      passwordError: "",
      confirmPasswordError: "",
      countryError: "",
      franchiseError: "",
    };
    if (firstName.trim() === "") {
      hasError = true;
      _errors = { ..._errors, firstNameError: "Field cannot be empty" };
    } else if (firstName?.length < 3) {
      hasError = true;
      _errors = { ..._errors, firstNameError: "Please enter a valid name" };
    }
    if (lastName.trim() === "") {
      hasError = true;
      _errors = { ..._errors, lastNameError: "Field cannot be empty" };
    } else if (lastName?.length < 3) {
      hasError = true;
      _errors = { ..._errors, lastNameError: "Please enter a valid last name" };
    }
    if (email.trim() === "") {
      hasError = true;
      _errors = { ..._errors, emailError: "Field cannot be empty" };
    } else if (!emailRegex.test(email)) {
      hasError = true;
      _errors = { ..._errors, emailError: "Please enter a valid Email" };
    }
    if (phone === "") {
      hasError = true;
      _errors = { ..._errors, phoneError: "Field cannot be empty" };
    } else if (phone?.length < 10) {
      hasError = true;
      _errors = { ..._errors, phoneError: "Please enter a valid Phone number" };
    } else if (!mobileRegex.test(phone)) {
      hasError = true;
      _errors = { ..._errors, phoneError: "Please enter a valid Phone number" };
    }
    if (password.trim() === "") {
      hasError = true;
      _errors = { ..._errors, passwordError: "Field cannot be empty" };
    } else if (password?.length < 8) {
      hasError = true;
      _errors = {
        ..._errors,
        passwordError: "Password must contain atleast 8 characters",
      };
    }
    if (confirmPassword.trim() === "") {
      hasError = true;
      _errors = { ..._errors, confirmPasswordError: "Field cannot be empty" };
    } else if (confirmPassword !== password) {
      hasError = true;
      _errors = { ..._errors, confirmPasswordError: "Password does not match" };
    }
    if (selectedCountryLocal === -1) {
      hasError = true;
      _errors = { ..._errors, countryError: "Please select a country" };
    }
    if (selectedFranchiseLocal === -1) {
      hasError = true;
      _errors = { ..._errors, franchiseError: "Please select a franchise" };
    }
    setErrors(_errors);
    return hasError;
  };

  const validateLocationModal = () => {
    let hasError = false;
    let _errors: SignupErrorModal = {
      firstNameError: "",
      lastNameError: "",
      emailError: "",
      phoneError: "",
      passwordError: "",
      confirmPasswordError: "",
      countryError: "",
      franchiseError: "",
    };
    if (phone === "") {
      hasError = true;
      _errors = { ..._errors, phoneError: "Field cannot be empty" };
    } else if (phone?.length < 10) {
      hasError = true;
      _errors = { ..._errors, phoneError: "Please enter a valid Phone number" };
    } else if (!mobileRegex.test(phone)) {
      hasError = true;
      _errors = { ..._errors, phoneError: "Please enter a valid Phone number" };
    }
    if (selectedCountryLocal === -1 || !selectedCountryLocal) {
      hasError = true;
      _errors = { ..._errors, countryError: "Please select a country" };
    }
    if (selectedFranchiseLocal === -1 || !selectedFranchiseLocal) {
      hasError = true;
      _errors = { ..._errors, franchiseError: "Please select a franchise" };
    }
    setErrors(_errors);
    return hasError;
  };

  const handleManualSignUp = () => {
    if (!validate()) {
      setIsSignUpLoading(true);
      const seletedFranchiseObj: FranchiseModal = franchiseList.find(
        (franchise: FranchiseModal) => franchise.id === selectedFranchiseLocal
      );
      const selectedCountryObj: CountryModal = countries.find(
        (contry: CountryModal) => contry.id === selectedCountryLocal
      );
      dispatch(
        manualSignupAction(
          {
            role: "CU",
            email: email,
            firstname: firstName,
            lastname: lastName,
            password: password,
            zipcode: "",
            dob: "",
            gender: "",
            phone: phone,
            user_country: selectedCountryObj?.iso,
            country_id: selectedCountryObj?.id,
            franchise: [
              { franchise_id: seletedFranchiseObj?.id, active: true },
            ],
            fromAdmin: false,
            is_verified: true,
          },
          (data: UserModal) => {
            // Temorary changes
            // setIsVerificationModalOpen(true);
            handleLogin();
          },
          () => {
            setIsSignUpLoading(false);
          }
        )
      );
    }
  };

  const handleLogin = () => {
    dispatch(
      manualSigninAction(
        {
          email,
          password,
          state: RoleSignIn.CU_APP,
        },
        async (data: any) => {
          props.onSuccess(data);
          setIsVerificationModalOpen(false);
          setIsSignUpLoading(false);
        }
      )
    );
  };

  const handleLocationSave = () => {
    if (!validateLocationModal()) {
      const { token, user } = localUser;
      const seletedFranchiseObj: FranchiseModal = franchiseList.find(
        (franchise: FranchiseModal) => franchise.id === selectedFranchiseLocal
      );
      const selectedCountryObj: CountryModal = countries.find(
        (contry: CountryModal) => contry.id === selectedCountryLocal
      );
      saveLocation(user, token, selectedCountryObj, seletedFranchiseObj);
    }
  };

  const saveLocation = (
    user: any,
    token: any,
    selectedCountryObj: any,
    seletedFranchiseObj: any
  ) => {
    let userInfoToSend: UsetInfoUpdateModal = {
      city_id: user.city_id,
      country_id: selectedCountryObj?.id || user?.country_id,
      email: user?.email || null,
      franchise: [{ franchise_id: seletedFranchiseObj?.id, active: true }],
      firstname: user?.firstname || null,
      lastname: user?.lastname || null,
      state_id: user?.state_id,
      zipcode: "",
      gender: "",
      dob: "",
      avatar: user?.avatar || null,
      role: "CU",
      status: true,
      card_data_changed: false,
      bank_data_changed: false,
      individual_data_changed: false,
      phone: phone,
    };
    setIsLoading(false);
    dispatch(
      updateGoogleFacebookUserAction(
        user?.id,
        userInfoToSend,
        async (userData: UserModal) => {
          dispatch({ type: SET_USER, payload: userData });
          dispatch({ type: SET_IS_LOGGED_IN, payload: true });
          await localStorage.setItem("userProfile", JSON.stringify(userData));
          await localStorage.setItem("token", token.token);
          props.onSuccess(userData);
          setIsLoading(false);
        },
        () => {
          setIsLoading(false);
        },
        { Authorization: `Bearer ${token.token}` }
      )
    );
  };

  const firstNameHandler = (text: string) => {
    setFirstName(text);
    setErrors({ ...errors, firstNameError: "" });
  };
  const lastNameHandler = (text: string) => {
    setLastName(text);
    setErrors({ ...errors, lastNameError: "" });
  };
  const emailHandler = (text: string) => {
    setEmail(text);
    setErrors({ ...errors, emailError: "" });
  };
  const phoneHandler = (text: string) => {
    setPhone(text);
    setErrors({ ...errors, phoneError: "" });
  };
  const passwordHandler = (text: string) => {
    setPassword(text);
    setErrors({ ...errors, passwordError: "" });
  };
  const confirnPasswordHandler = (text: string) => {
    setConfirmPassword(text);
    setErrors({ ...errors, confirmPasswordError: "" });
  };
  const countryHandler = (id: number) => {
    setSelectedCountryLocal(id);
    setErrors({ ...errors, countryError: "" });
  };
  const franchiseHandler = (id: number) => {
    setSelectedFranchiseLocal(id);
    setErrors({ ...errors, franchiseError: "" });
  };

  // const handleGoogleSignIn = (event: any) => {
  //   const { accessToken } = event;
  //   if (accessToken) {
  //     dispatch(setLoaderStateAction(true));
  //     dispatch(
  //       postOauthAction(
  //         "google",
  //         {
  //           accessToken,
  //           token: "",
  //         },
  //         async (result: any) => {
  //           const { user, token } = result;
  //           if (user?.Franchise?.length > 0) {
  //             dispatch({ type: SET_USER, payload: user });
  //             dispatch({ type: SET_IS_LOGGED_IN, payload: true });
  //             await localStorage.setItem("userProfile", JSON.stringify(user));
  //             await localStorage.setItem("token", token.token);
  //             dispatch(setLoaderStateAction(false));
  //             props.onSuccess();
  //           } else {
  //             setLocalUser(result);
  //             setIsSelectLocationModalOpen(true);
  //             dispatch(setLoaderStateAction(false));
  //           }
  //         },
  //         () => {
  //           dispatch(setLoaderStateAction(false));
  //         }
  //       )
  //     );
  //   }
  // };

  const handleFacebookSignIn = (event: any) => {
    const { accessToken } = event;
    if (accessToken) {
      dispatch(setLoaderStateAction(true));
      dispatch(
        postOauthAction(
          "facebook",
          {
            accessToken,
            token: "",
          },
          async (result: any) => {
            const { user, token } = result;
            if (user?.Franchise?.length > 0) {
              dispatch({ type: SET_USER, payload: user });
              dispatch({ type: SET_IS_LOGGED_IN, payload: true });
              await localStorage.setItem("userProfile", JSON.stringify(user));
              await localStorage.setItem("token", token.token);
              dispatch(setLoaderStateAction(false));
              props.onSuccess(result);
            } else {
              setLocalUser(result);
              setIsSelectLocationModalOpen(true);
              dispatch(setLoaderStateAction(false));
            }
          },
          () => {
            dispatch(setLoaderStateAction(false));
          }
        )
      );
    }
  };

  const appleResponse = (response: any) => {
    let res = {
      appleAuthRequestResponse: response,
      accessToken: response.authorization.id_token,
    };
    if (!response.error) {
      dispatch(
        appleSignupAction(res, async (data: any) => {
          const { user, token } = data;
          if (user?.Franchise?.length > 0) {
            dispatch({ type: SET_USER, payload: user });
            dispatch({ type: SET_IS_LOGGED_IN, payload: true });
            await localStorage.setItem("userProfile", JSON.stringify(user));
            await localStorage.setItem("token", token.token);
            dispatch(setLoaderStateAction(false));
            props.onSuccess(data);
          } else {
            setLocalUser(data);
            setIsSelectLocationModalOpen(true);
            dispatch(setLoaderStateAction(false));
          }
        })
      );
    }
  };

  const renderSocialMediaButtons = () => {
    return (
      <Row className="justify-content-center pt-4">
        <Col
          xxl="4"
          xl="4"
          lg="4"
          md="4"
          sm="12"
          className="d-flex justify-content-center"
        >
          <FacebookLogin
            appId="802799357670504"
            fields="name,email,picture"
            scope="public_profile,user_friends,user_actions.books"
            cssClass="social-login-btn"
            callback={(event) => {
              console.log(event);
              handleFacebookSignIn(event);
            }}
            size="small"
            textButton=""
            icon={
              <Image
                src={SIGN_IN_WITH_FACEBOOK}
                alt="sign in with facebook"
                className="w-100"
              />
            }
          />
        </Col>
        {/* <Col
          xxl="4"
          xl="4"
          lg="4"
          md="4"
          sm="12"
          className="d-flex justify-content-center mt-md-0 mt-sm-2"
        >
          <GoogleLogin
            clientId={clientId}
            buttonText="Login"
            onSuccess={handleGoogleSignIn}
            onFailure={(error) => {
              console.error(error);
            }}
            cookiePolicy={"single_host_origin"}
            render={(renderProps) => (
              <button
                className="social-login-btn"
                onClick={renderProps?.onClick}
              >
                <Image
                  src={SIGN_IN_WITH_GOOGLE}
                  alt="sign in with google"
                  className="w-100"
                />
              </button>
            )}
          />
        </Col> */}
        <RenderInBrowser safari mobile only>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="12"
            className="d-flex justify-content-center mt-md-0 mt-sm-2"
          >
            <AppleSignin
              /** Auth options passed to AppleID.auth.init() */
              authOptions={{
                /** Client ID - eg: 'com.example.com' */
                clientId: "com.sendmeatrainer.webapp",
                /** Requested scopes, seperated by spaces - eg: 'email name' */
                scope: "email name",
                /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
                redirectURI: "https://dev-webapp.sendmeatrainer.com",
                /** State string that is returned with the apple response */
                state: "state",
                /** Nonce */
                nonce: "nonce",
                /** Uses popup auth instead of redirection */
                usePopup: true,
              }} // REQUIRED
              /** General props */
              uiType="dark"
              /** className */
              className="apple-auth-btn"
              /** Removes default style tag */
              noDefaultStyle={false}
              /** Allows to change the button's children, eg: for changing the button text */
              buttonExtraChildren="Continue with Apple"
              /** Extra controlling props */
              /** Called upon signin success in case authOptions.usePopup = true -- which means auth is handled client side */
              onSuccess={(response: any) => appleResponse(response)} // default = undefined
              /** Called upon signin error */
              onError={(error: any) => console.error(error)} // default = undefined
              /** Skips loading the apple script if true */
              skipScript={false} // default = undefined
              /** Apple image props */
              iconProp={{ style: { marginTop: "10px" } }} // default = undefined
              /** render function - called with all props - can be used to fully customize the UI by rendering your own component  */
              render={(props: any) => (
                <button
                  {...props}
                  className="social-login-btn"
                  onClick={props.onClick}
                >
                  <Image
                    src={SIGN_IN_WITH_APPLE}
                    alt="sign in with apple"
                    className="w-100"
                  />
                </button>
              )}
            />
          </Col>
        </RenderInBrowser>
      </Row>
    );
  };

  const renderSignupForm = () => {
    return (
      <Row className="justify-content-center pt-5 border-bottom">
        <Col xxl="7" xl="7" lg="7" md="9" sm="12" xs="12" className="pb-5">
          <Form.Group className="mb-3">
            <Row>
              <Col xxl="6" xl="6" lg="6" md="6" sm="12" xs="12">
                <Form.Label>First Name *</Form.Label>
                <Form.Control
                  onChange={(e) => firstNameHandler(e.target.value)}
                  value={firstName}
                  type="text"
                  placeholder="Enter Firstname"
                />
                <Form.Text className="text-danger">
                  {errors.firstNameError}
                </Form.Text>
              </Col>
              <Col xxl="6" xl="6" lg="6" md="6" sm="12" xs="12">
                <Form.Label>Last Name *</Form.Label>
                <Form.Control
                  onChange={(e) => lastNameHandler(e.target.value)}
                  value={lastName}
                  type="text"
                  placeholder="Enter Lastname"
                />
                <Form.Text className="text-danger">
                  {errors.lastNameError}
                </Form.Text>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email *</Form.Label>
            <Form.Control
              onChange={(e) => emailHandler(e.target.value)}
              value={email}
              type="email"
              placeholder="Enter Email"
            />
            <Form.Text className="text-danger">{errors.emailError}</Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Phone Number *</Form.Label>
            <PhoneInput
              countries={["US", "AE", "GB", "CA"]}
              addInternationalOption={false}
              defaultCountry="US"
              placeholder="Enter Phone Number"
              limitMaxLength={true}
              value={phone}
              onChange={(number: string) => {
                phoneHandler(number);
              }}
            />
            <Form.Text className="text-danger">{errors.phoneError}</Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password *</Form.Label>
            <InputGroup>
              <Form.Control
                onChange={(e) => passwordHandler(e.target.value)}
                value={password}
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Enter Password"
              />
              <InputGroup.Text id="basic-addon2">
                <FontAwesomeIcon
                  onClick={() => {
                    setIsPasswordVisible(!isPasswordVisible);
                  }}
                  role={"button"}
                  icon={isPasswordVisible ? faEye : faEyeSlash}
                />
              </InputGroup.Text>
            </InputGroup>
            <Form.Text className="text-danger">
              {errors.passwordError}
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Confirm Password *</Form.Label>
            <InputGroup>
              <Form.Control
                onChange={(e) => confirnPasswordHandler(e.target.value)}
                value={confirmPassword}
                type={isConfirmPasswordVisible ? "text" : "password"}
                placeholder="Enter Password"
              />
              <InputGroup.Text id="basic-addon2">
                <FontAwesomeIcon
                  onClick={() => {
                    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
                  }}
                  role={"button"}
                  icon={isConfirmPasswordVisible ? faEye : faEyeSlash}
                />
              </InputGroup.Text>
            </InputGroup>
            <Form.Text className="text-danger">
              {errors.confirmPasswordError}
            </Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Country *</Form.Label>
            <Form.Select
              value={selectedCountryLocal}
              onChange={(event) => {
                countryHandler(+event.target.value);
              }}
            >
              <option value={"-1"} selected disabled>
                Please select Country
              </option>
              {countries.map((country: CountryModal) => {
                return (
                  <option value={country.id} key={country.id}>
                    {country.name}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Text className="text-danger">{errors.countryError}</Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Location *</Form.Label>
            <Form.Select
              value={selectedFranchiseLocal}
              onChange={(event) => {
                franchiseHandler(+event.target.value);
              }}
            >
              <option value={"-1"} selected disabled>
                Please select Location
              </option>
              {localFranchiseList.map((franchise: FranchiseModal) => {
                return (
                  <option value={franchise.id} key={franchise.id}>
                    {franchise.name}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Text className="text-danger">
              {errors.franchiseError}
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
    );
  };

  const renderActions = () => {
    return (
      <Row className="justify-content-center pt-4 pb-4">
        <Col xxl="5" xl="5" lg="5" md="6" sm="12" xs="12">
          <button
            type="button"
            className="btn background-primary border-color-primary text-light input-label w-100"
            onClick={handleManualSignUp}
            disabled={isSignUpLoading}
          >
            {isSignUpLoading ? (
              <Spinner size="sm" animation="border" variant="light" />
            ) : (
              "Sign Up"
            )}
          </button>
          <p className="mt-2 already-account text-center">
            Already have an account? Log In please
          </p>
          <button
            type="button"
            onClick={() => props.toggleMode && props.toggleMode(true)}
            className="btn background-primary border-color-primary text-light input-label w-100"
            disabled={isSignUpLoading}
          >
            {isSignUpLoading ? (
              <Spinner size="sm" animation="border" variant="light" />
            ) : (
              "Log In"
            )}
          </button>
        </Col>
      </Row>
    );
  };

  // const onSuccessSkip = (response: any) => {
  //   setLocalUser(response);
  //   if (selectedCountry?.id && selectedFranchise?.id) {
  //     const { user, token } = response;
  //     saveLocation(user, token, selectedCountry, selectedFranchise);
  //   } else {
  //     setIsSelectLocationModalOpen(true);
  //   }
  // };

  return (
    <Container fluid>
      {isSelectLocationModalOpen && (
        <>
          <Row className="justify-content-center pt-5 border-bottom">
            <Col xxl="7" xl="7" lg="7" md="9" sm="12" xs="12" className="pb-5">
              <Form.Group className="mb-3">
                <Form.Label>Phone Number *</Form.Label>
                <PhoneInput
                  countries={["US", "AE", "GB", "CA"]}
                  addInternationalOption={false}
                  defaultCountry="US"
                  placeholder="Enter Phone Number"
                  limitMaxLength={true}
                  value={phone}
                  onChange={(number: string) => {
                    phoneHandler(number);
                  }}
                />
                <Form.Text className="text-danger">
                  {errors.phoneError}
                </Form.Text>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Country</Form.Label>
                <Form.Select
                  value={selectedCountryLocal}
                  onChange={(event) => {
                    countryHandler(+event.target.value);
                  }}
                >
                  <option value={-1} selected disabled>
                    Please select Country
                  </option>
                  {countries.map((country: CountryModal) => {
                    return (
                      <option value={country.id} key={country.id}>
                        {country.name}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Text className="text-danger">
                  {errors.countryError}
                </Form.Text>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Location</Form.Label>
                <Form.Select
                  value={selectedFranchiseLocal}
                  onChange={(event) => {
                    franchiseHandler(+event.target.value);
                  }}
                >
                  <option value={-1} selected disabled>
                    Please select Location
                  </option>
                  {localFranchiseList.map((franchise: FranchiseModal) => {
                    return (
                      <option value={franchise.id} key={franchise.id}>
                        {franchise.name}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Text className="text-danger">
                  {errors.franchiseError}
                </Form.Text>
              </Form.Group>
              <Button
                variant="primary"
                className="background-primary border-color-primary font-family-poppins text-light w-100 mt-3"
                onClick={handleLocationSave}
              >
                Save
              </Button>
            </Col>
          </Row>
          {isLoading && (
            <div className="overlay">
              <Spinner animation="grow" variant="info" />
            </div>
          )}
        </>
      )}
      {isVerificationModalOpen && (
        <Col
          xxl="12"
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          className="d-flex flex-column align-items-center"
        >
          <FontAwesomeIcon icon={faEnvelopeOpenText} className="mb-3 h1" />
          <p>We have sent you a link over the Email</p>
          <Button
            variant="primary"
            className="background-primary border-color-primary font-family-poppins text-light w-50"
            onClick={handleLogin}
          >
            Login
          </Button>
        </Col>
      )}
      {!isSelectLocationModalOpen && !isVerificationModalOpen && (
        <Row className="justify-content-center border-bottom">
          <Col xxl="12">
            <Row className="border-bottom">
              <Col className="position-relative pb-3" xs="12">
                <FontAwesomeIcon
                  onClick={isSignUpLoading ? () => {} : props.hideModal}
                  role={"button"}
                  className="ms-1"
                  size="1x"
                  icon={faXmark}
                />
                <p className="fs-5 text-sm-center p-0 m-0 fw-bolder">
                  Create Your Account
                </p>
                {!props?.noSkip ? (
                  <div className="position-absolute top-0 end-0">
                    {/* <SkipButton onSuccessSkip={onSuccessSkip} /> */}
                  </div>
                ) : null}
              </Col>
            </Row>
            {renderSocialMediaButtons()}
            {renderSignupForm()}
            {renderActions()}
          </Col>
        </Row>
      )}
    </Container>
  );
};

export { SignupComponent };
